<template>
	<div class="gh-layout">
		<aside class="gh-intro">
			<h2 class="gh-intro__title">Import / Export</h2>
			<p class="gh-intro__desc">Importing and exporting data.</p>
		</aside>

		<section class="gh-accounts">
			<div class="ada-card">
				<div class="gh-section__title">Municipalities Data Entry</div>
				<!-- Input + dugme u istom redu -->
				<div class="input-group mb-3">
					<input
						type="file"
						name="municipalitiesDataEntryFile"
						ref="municipalitiesDataEntryFileInput"
						class="form-control"
						@change="municipalitiesDataEntryHandleFileChange"
					/>
					<div class="input-group-append">
						<button
							class="btn btn-primary"
							type="button"
							@click="municipalitiesDataEntryUploadFile"
							:disabled="!municipalitiesDataEntryFile || municipalitiesDataEntryIsUploading"
						>
							Import
						</button>
					</div>
				</div>

				<!-- Progress bar -->
				<div v-if="municipalitiesDataEntryIsUploading" class="progress">
					<div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{ width: municipalitiesDataEntryProgress + '%' }">
						{{ municipalitiesDataEntryProgress }}%
					</div>
				</div>

				<!-- Info poruka o import statusu -->
				<div v-if="municipalitiesDataEntryShowInfo" class="alert alert-info mt-3" role="alert">
					{{ municipalitiesDataEntryStatusInfo }}
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import restApi from '../../api/index.js'
import { handleErrors } from '../../actions/helpers.js'
export default {
	name: 'ImportExportSettings',
	data() {
		return {
			name: 'ImportExportSettings',
			type: 'settings',
			settings: {
				consumerKey: '',
			},
			municipalitiesDataEntryFile: null,
			municipalitiesDataEntryIsUploading: false,
			municipalitiesDataEntryProgress: 0,
			municipalitiesDataEntryStatusMessage: '',
			municipalitiesDataEntryUploadSuccess: false,
			municipalitiesDataEntryStatusInfo: '',
			municipalitiesDataEntryShowInfo: false,
			municipalitiesDataEntryInfoTimeout: null,
		}
	},
	created() {
		this.getSettings()
	},
	methods: {
		getSettings() {
			restApi
				.get('/settings', { params: { name: this.name, type: this.type } })
				.then(({ data }) => {
					if (data) {
						this.settings = JSON.parse(data.data)
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		municipalitiesDataEntrySetInfoMessage(msg) {
			this.municipalitiesDataEntryStatusInfo = msg
			this.municipalitiesDataEntryShowInfo = true

			if (this.municipalitiesDataEntryInfoTimeout) {
				clearTimeout(this.municipalitiesDataEntryInfoTimeout)
			}

			this.municipalitiesDataEntryInfoTimeout = setTimeout(() => {
				this.municipalitiesDataEntryShowInfo = false
				this.municipalitiesDataEntryStatusInfo = ''
			}, 10000)
		},
		municipalitiesDataEntryHandleFileChange(event) {
			this.municipalitiesDataEntryFile = event.target.files[0]
			this.municipalitiesDataEntryStatusMessage = ''
		},
		municipalitiesDataEntryUploadFile() {
			if (!this.municipalitiesDataEntryFile) return

			const formData = new FormData()
			formData.append('file', this.municipalitiesDataEntryFile)

			this.municipalitiesDataEntryIsUploading = true
			this.municipalitiesDataEntryProgress = 0
			this.municipalitiesDataEntryStatusMessage = ''

			restApi
				.post('/import/municipalitiesDeImport', formData, {
					headers: { 'Content-Type': 'multipart/form-data' },
					onUploadProgress: e => {
						if (e.lengthComputable) {
							this.municipalitiesDataEntryProgress = Math.round((e.loaded * 100) / e.total)
						}
					},
				})
				.then(response => {
					this.municipalitiesDataEntryUploadSuccess = true
					this.municipalitiesDataEntryStatusMessage = 'Upload successful!'
					// Prikazivanje dodatnog info statusa (npr. updated/skipped)
					const data = response.data
					let info = `Updated: ${data.updated_rows || 0}, Skipped: ${data.skipped_rows || 0}`

					if (data.not_found_ids) {
						info += `, Not Found: ${data.not_found_ids}`
					}

					this.municipalitiesDataEntrySetInfoMessage(info)
				})
				.catch(() => {
					this.municipalitiesDataEntryUploadSuccess = false
					this.municipalitiesDataEntryStatusMessage = 'Upload failed. Please try again.'
				})
				.finally(() => {
					this.municipalitiesDataEntryUploading = false

					// 🔁 Reset file input i data
					this.$refs.municipalitiesDataEntryFileInput.value = null
					this.municipalitiesDataEntrySelectedFile = null
					// ⏳ Hide progress bar after 500ms
					setTimeout(() => {
						this.municipalitiesDataEntryIsUploading = false
						this.municipalitiesDataEntryProgress = 0
					}, 500)
				})
		},
	},
}
</script>
